import { Injectable } from '@angular/core';
import { LoginLibService } from '@ebootis/login';
import { LogisticAreaService } from '../../modules/shared/logistic-area/logistic-area.service';
import { ConfigurationService } from '../configuration-select/configuration.service';

@Injectable({
	providedIn: 'root',
	deps: [LoginLibService, LogisticAreaService, ConfigurationService],
})
export class LogoutService {

	constructor(
		private m_loginLibService: LoginLibService,
		private m_logisticAreaService: LogisticAreaService,
		private m_configurationService: ConfigurationService) {
	}

	/**
	 * LogisticArea sowie Configuration wird entfernt. Logout wird durch loginService durchgeführt.
	 */
	public logout() {
		this.m_logisticAreaService.removeLogisticArea();
		this.m_configurationService.removeConfigSelected();
		return this.m_loginLibService.logout();
	}

}
